'use strict';

import Vue from 'vue';

export default input => {
    if (typeof Vue.i18n === 'undefined') {
        return '';
    }
    let amount       = typeof input === 'object' ? input.toFixed() : input,
        newAmount    = amount,
        locale       = Vue.i18n.locale(),
        postfix      = '',
        formattedAmount;
    if (amount >= 1e100) {
        newAmount = amount / 1e100;
        postfix = 'NUM1E100';
    } else if (amount >= 1e99) {
        newAmount = amount / 1e99;
        postfix = 'NUM1E99';
    } else if (amount >= 1e96) {
        newAmount = amount / 1e96;
        postfix = 'NUM1E96';
    } else if (amount >= 1e93) {
        newAmount = amount / 1e93;
        postfix = 'NUM1E93';
    } else if (amount >= 1e90) {
        newAmount = amount / 1e90;
        postfix = 'NUM1E90';
    } else if (amount >= 1e87) {
        newAmount = amount / 1e87;
        postfix = 'NUM1E87';
    } else if (amount >= 1e84) {
        newAmount = amount / 1e84;
        postfix = 'NUM1E84';
    } else if (amount >= 1e81) {
        newAmount = amount / 1e81;
        postfix = 'NUM1E81';
    } else if (amount >= 1e78) {
        newAmount = amount / 1e78;
        postfix = 'NUM1E78';
    } else if (amount >= 1e75) {
        newAmount = amount / 1e75;
        postfix = 'NUM1E75';
    } else if (amount >= 1e72) {
        newAmount = amount / 1e72;
        postfix = 'NUM1E72';
    } else if (amount >= 1e69) {
        newAmount = amount / 1e69;
        postfix = 'NUM1E69';
    } else if (amount >= 1e66) {
        newAmount = amount / 1e66;
        postfix = 'NUM1E66';
    } else if (amount >= 1e63) {
        newAmount = amount / 1e63;
        postfix = 'NUM1E63';
    } else if (amount >= 1e60) {
        newAmount = amount / 1e60;
        postfix = 'NUM1E60';
    } else if (amount >= 1e57) {
        newAmount = amount / 1e57;
        postfix = 'NUM1E57';
    } else if (amount >= 1e54) {
        newAmount = amount / 1e54;
        postfix = 'NUM1E54';
    } else if (amount >= 1e51) {
        newAmount = amount / 1e51;
        postfix = 'NUM1E51';
    } else if (amount >= 1e48) {
        newAmount = amount / 1e48;
        postfix = 'NUM1E48';
    } else if (amount >= 1e45) {
        newAmount = amount / 1e45;
        postfix = 'NUM1E45';
    } else if (amount >= 1e42) {
        newAmount = amount / 1e42;
        postfix = 'NUM1E42';
    } else if (amount >= 1e39) {
        newAmount = amount / 1e39;
        postfix = 'NUM1E39';
    } else if (amount >= 1e36) {
        newAmount = amount / 1e36;
        postfix = 'NUM1E36';
    } else if (amount >= 1e33) {
        newAmount = amount / 1e33;
        postfix = 'NUM1E33';
    } else if (amount >= 1e30) {
        newAmount = amount / 1e30;
        postfix = 'NUM1E30';
    } else if (amount >= 1e27) {
        newAmount = amount / 1e27;
        postfix = 'NUM1E27';
    } else if (amount >= 1e24) {
        newAmount = amount / 1e24;
        postfix = 'NUM1E24';
    } else if (amount >= 1e21) {
        newAmount = amount / 1e21;
        postfix = 'NUM1E21';
    } else if (amount >= 1e18) {
        newAmount = amount / 1e18;
        postfix = 'NUM1E18';
    } else if (amount >= 1e15) {
        newAmount = amount / 1e15;
        postfix = 'NUM1E15';
    } else if (amount >= 1e12) {
        newAmount = amount / 1e12;
        postfix = 'NUM1E12';
    } else if (amount >= 1e9) {
        newAmount = amount / 1e9;
        postfix = 'NUM1E09';
    } else if (amount >= 1e6) {
        newAmount = amount / 1e6;
        postfix = 'NUM1E06';
    }
    formattedAmount = Vue.options.filters.Currency(newAmount, '', 2, locale);
    postfix = postfix !== '' ? ' ' + Vue.i18n.translate(postfix) : '';
    return locale === 'de'
        ? `${formattedAmount}${postfix} €`
        : `$${formattedAmount}${postfix}`;
};
